var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar" },
    [
      _c("nav", { staticClass: "sidebar-nav" }, [
        _c("div", { staticClass: "avatar" }, [
          _c("div", { staticClass: "l-avatar-wrap pointer" }, [
            _c(
              "a",
              { attrs: { href: "#" }, on: { click: _vm.showNotifications } },
              [
                _vm.unreadNotifications
                  ? _c("span", { staticClass: "notify-badge" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.unreadNotifications) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("img", {
                  staticClass: "l-avatar profile",
                  attrs: { src: require("../../assets/img/avatar.png") }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.user.first_name)),
            _c("br"),
            _vm._v(_vm._s(_vm.user.last_name))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-link text-white",
              attrs: { type: "button" },
              on: { click: _vm.logout }
            },
            [_c("i", { staticClass: "fa fa-sign-out text-white" })]
          )
        ]),
        _vm._v(" "),
        _vm.permissions && !_vm.user.company_setup_step
          ? _c("ul", { staticClass: "tier-1" }, [
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "sidebar-item",
                      attrs: { to: "/", exact: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.clickLink($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "mod-icon mod-icon-dashboard" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "l-menu-title" }, [
                        _vm._v("Dashboard")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _vm.$_can("leads.index") || _vm.$_can("leads.index-own")
                    ? _c(
                        "router-link",
                        {
                          staticClass: "sidebar-item",
                          attrs: { to: "/leads" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.clickLink($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "mod-icon mod-icon-leads" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "l-menu-title" }, [
                            _vm._v("Leads")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _vm.$_can("jobs.index") || _vm.$_can("jobs.index-own")
                    ? _c(
                        "router-link",
                        {
                          staticClass: "sidebar-item",
                          attrs: { to: "/jobs" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.clickLink($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "mod-icon mod-icon-jobs" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "l-menu-title" }, [
                            _vm._v("Jobs")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _vm.$_can("claims.index") || _vm.$_can("claims.index-own")
                    ? _c(
                        "router-link",
                        {
                          staticClass: "sidebar-item",
                          attrs: { to: "/claims" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.clickLink($event)
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "mod-icon mod-icon-claims"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "l-menu-title" }, [
                            _vm._v("Claims")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tier-2-overlay" }, [
                _c("div", { staticClass: "tier-2-background-wrap" }),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "sidebar-item sidebar-item-sub",
                      attrs: { href: "#" }
                    },
                    [
                      _c("div", {
                        staticClass: "mod-icon mod-icon-main-users"
                      }),
                      _vm._v(" "),
                      _vm.$_can("carriers.index") ||
                      _vm.$_can("companies.index") ||
                      _vm.$_can("clusters.users.index") ||
                      _vm.$_can("companies.customers.index") ||
                      _vm.$_can("carriers.movers.index") ||
                      _vm.$_can("carriers.trucks.index")
                        ? _c("ul", { staticClass: "tier-2" }, [
                            _c(
                              "li",
                              [
                                _vm.$_can("companies.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/companies" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-companies"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Companies")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("carriers.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/carriers" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-groups"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Carriers")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("clusters.users.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/users" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-sub-users"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Users")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("companies.customers.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/customers" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-customers"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Customers")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("carriers.movers.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/movers" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-movers"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Movers")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("carriers.trucks.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/trucks" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-trucks"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Trucks")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.$_can("job-charges.index") || _vm.canAccessPayments
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "sidebar-item sidebar-item-sub",
                          attrs: { href: "#" }
                        },
                        [
                          _c("div", {
                            staticClass: "mod-icon mod-icon-payments"
                          }),
                          _vm._v(" "),
                          _vm.$_can("job-charges.index") ||
                          _vm.canAccessPayments
                            ? _c(
                                "ul",
                                { staticClass: "tier-2" },
                                [
                                  _vm.$_can("job-charges.index")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass: "sidebar-item",
                                          attrs: { to: "/transactions" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.clickLink($event)
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "mod-icon mod-icon-transactions"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Transactions")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canAccessPayments
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass: "sidebar-item",
                                          attrs: {
                                            to: "/settings/payment-gateways"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.clickLink($event)
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "mod-icon mod-icon-gateways"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Payment gateways")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$_can("leads.follow-up-email-templates.index") ||
                _vm.$_can("phone-numbers.index") ||
                _vm.$_can("leads.follow-ups.index") ||
                _vm.$_can("carriers.roles.index") ||
                _vm.$_can("companies.domains.index") ||
                _vm.$_can("companies.configurations.index")
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "sidebar-item sidebar-item-sub",
                          attrs: { href: "#" }
                        },
                        [
                          _c("div", {
                            staticClass: "mod-icon mod-icon-settings"
                          }),
                          _vm._v(" "),
                          _c("ul", { staticClass: "tier-2" }, [
                            _c("li", [
                              _vm.$_can("companies.domains.index") ||
                              _vm.$_can("leads.follow-up-email-templates.index")
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "sidebar-item",
                                      attrs: { href: "#" }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "mod-icon mod-icon-mailing"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "l-sidebar-menu-title" },
                                        [_vm._v("Mailing")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "overlay-blue"
                                      }),
                                      _vm._v(" "),
                                      _c("ul", { staticClass: "tier-3" }, [
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "sidebar-item",
                                                attrs: {
                                                  to: "/settings/smtp-servers"
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.clickLink($event)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "l-sidebar-menu-title"
                                                  },
                                                  [_vm._v("SMTP servers")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          [
                                            _vm.$_can(
                                              "leads.follow-up-email-templates.index"
                                            )
                                              ? _c(
                                                  "router-link",
                                                  {
                                                    staticClass: "sidebar-item",
                                                    attrs: {
                                                      to:
                                                        "/settings/follow-up-templates"
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickLink(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "l-sidebar-menu-title"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Follow up templates"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          [
                                            _vm.$_can(
                                              "claims.email-templates.index"
                                            )
                                              ? _c(
                                                  "router-link",
                                                  {
                                                    staticClass: "sidebar-item",
                                                    attrs: {
                                                      to:
                                                        "/settings/claim-templates"
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickLink(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "l-sidebar-menu-title"
                                                      },
                                                      [_vm._v("Claim emails")]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          [
                                            _vm.$_can(
                                              "claims.acknowledgement-email-templates.index"
                                            )
                                              ? _c(
                                                  "router-link",
                                                  {
                                                    staticClass: "sidebar-item",
                                                    attrs: {
                                                      to:
                                                        "/settings/acknowledgement-templates"
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickLink(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "l-sidebar-menu-title"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Acknowledgement emails"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          [
                                            _vm.$_can(
                                              "claims.settlement-email-templates.index"
                                            )
                                              ? _c(
                                                  "router-link",
                                                  {
                                                    staticClass: "sidebar-item",
                                                    attrs: {
                                                      to:
                                                        "/settings/settlement-templates"
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickLink(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "l-sidebar-menu-title"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Settlement emails"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("carriers.roles.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/settings/user-roles" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-user-roles"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("User roles")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("phone-numbers.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: {
                                          to: "/settings/phone-numbers"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-phone-numbers"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Phone Numbers")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "sidebar-item",
                                  attrs: { href: "#" }
                                },
                                [
                                  _c("div", {
                                    staticClass: "mod-icon mod-icon-messages"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "l-sidebar-menu-title" },
                                    [_vm._v("Messages")]
                                  ),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "tier-3" }, [
                                    _c(
                                      "li",
                                      [
                                        _vm.$_can(
                                          "settings.messages.index-all"
                                        ) ||
                                        _vm.$_can("settings.messages.index-own")
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass: "sidebar-item",
                                                attrs: {
                                                  to: "/settings/messages"
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.clickLink($event)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "l-sidebar-menu-title"
                                                  },
                                                  [_vm._v("Customer Messages")]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      [
                                        _vm.$_can(
                                          "carriers.movers.get-text-message-threads"
                                        )
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass: "sidebar-item",
                                                attrs: {
                                                  to: "/settings/mover-messages"
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.clickLink($event)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "l-sidebar-menu-title"
                                                  },
                                                  [_vm._v("Mover Messages")]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.$_can("companies.configurations.index")
                              ? _c(
                                  "li",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/rates" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "mod-icon mod-icon-rates"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Rates")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("claims.types.index")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/settings/claim-types" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "mod-icon mod-icon-user-roles"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Claim Types")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "sidebar-item",
                                    attrs: { to: "/contracts" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.clickLink($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "mod-icon mod-icon-contracts"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "l-sidebar-menu-title" },
                                      [_vm._v("Contracts")]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$_can("tags.show")
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "sidebar-item",
                                        attrs: { to: "/settings/tags" },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickLink($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "mod-icon mod-icon-tags"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "l-sidebar-menu-title"
                                          },
                                          [_vm._v("Tags")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "sidebar-item",
                                    attrs: { to: "/settings/filters" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.clickLink($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "mod-icon mod-icon-filters"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "l-sidebar-menu-title" },
                                      [_vm._v("Filters")]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$_can("clusters.totals.index") ||
                _vm.$_can("movers.wages.index")
                  ? _c(
                      "li",
                      {
                        nativeOn: {
                          click: function($event) {
                            return _vm.clickLink($event)
                          }
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "sidebar-item sidebar-item-sub",
                            attrs: { href: "#" }
                          },
                          [
                            _c("div", {
                              staticClass: "mod-icon mod-icon-reports"
                            }),
                            _vm._v(" "),
                            _vm.$_can("clusters.totals.index") ||
                            _vm.$_can("movers.wages.index")
                              ? _c("ul", { staticClass: "tier-2" }, [
                                  _c(
                                    "li",
                                    [
                                      _vm.$_can("clusters.totals.index")
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "sidebar-item",
                                              attrs: { to: "/reports/totals" },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.clickLink($event)
                                                }
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "mod-icon mod-icon-totals"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "l-sidebar-menu-title"
                                                },
                                                [_vm._v("Totals")]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    [
                                      _vm.$_can("movers.wages.index")
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "sidebar-item",
                                              attrs: {
                                                to: "/reports/mover-totals"
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.clickLink($event)
                                                }
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "mod-icon mod-icon-money"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "l-sidebar-menu-title"
                                                },
                                                [_vm._v("Mover Totals")]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    [
                                      _vm.$_can("sales.view-totals")
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "sidebar-item",
                                              attrs: { to: "/reports/sales" },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.clickLink($event)
                                                }
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "mod-icon mod-icon-money"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "l-sidebar-menu-title"
                                                },
                                                [_vm._v("Sales Totals")]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    [
                                      _vm.$_can("job-discounts.index")
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "sidebar-item",
                                              attrs: {
                                                to: "/reports/discounts"
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.clickLink($event)
                                                }
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "mod-icon mod-icon-money"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "l-sidebar-menu-title"
                                                },
                                                [_vm._v("Discounts")]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "sidebar-item",
                                          attrs: { to: "/reports/ratings" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.clickLink($event)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mod-icon fa fa-star text-white"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "l-sidebar-menu-title"
                                            },
                                            [_vm._v("Ratings")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("router-link", {
                    staticClass: "sidebar-item logo",
                    attrs: { to: "/" }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.user.company_setup_step
          ? _c("ul", { staticClass: "tier-1 help" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("router-link", {
                    staticClass: "sidebar-item logo",
                    attrs: { to: "/" }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "nav",
        { staticClass: "mobile navbar navbar-light navbar-1" },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center menu-item-wrapper" },
            [
              _c(
                "button",
                {
                  staticClass: "navbar-toggler",
                  on: { click: _vm.toggleMenu }
                },
                [_c("i", { staticClass: "fa fa-bars hamburger-icon" })]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  attrs: {
                    width: "48",
                    height: "17",
                    viewBox: "0 0 48 17",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink"
                  }
                },
                [
                  _c("rect", {
                    attrs: { width: "48", height: "17", fill: "url(#pattern0)" }
                  }),
                  _vm._v(" "),
                  _c("defs", [
                    _c(
                      "pattern",
                      {
                        attrs: {
                          id: "pattern0",
                          patternContentUnits: "objectBoundingBox",
                          width: "1",
                          height: "1"
                        }
                      },
                      [
                        _c("use", {
                          attrs: {
                            "xlink:href": "#image0",
                            transform: "scale(0.00714286 0.0196078)"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("image", {
                      attrs: {
                        id: "image0",
                        width: "140",
                        height: "51",
                        "xlink:href":
                          "data:image/png;base64,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"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "avatar" }, [
                _c("div", { staticClass: "l-avatar-wrap pointer" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: { click: _vm.showNotifications }
                    },
                    [
                      _vm.unreadNotifications
                        ? _c("span", { staticClass: "notify-badge" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.unreadNotifications) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "l-avatar profile",
                        attrs: { src: require("../../assets/img/avatar.png") }
                      })
                    ]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide" } }, [
            _vm.mobileMenu
              ? _c(
                  "div",
                  { staticClass: "r-modal-mask" },
                  [
                    _c("MobileSidenav", {
                      directives: [
                        {
                          name: "scroll-lock",
                          rawName: "v-scroll-lock",
                          value: _vm.mobileMenu,
                          expression: "mobileMenu"
                        }
                      ],
                      staticClass: "mobile-sidebar",
                      attrs: { user: _vm.user },
                      on: {
                        close: _vm.toggleMenu,
                        clickLink: _vm.clickLink,
                        logout: _vm.logout
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.notificationsSidebar
          ? _c(
              "div",
              {
                staticClass: "r-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.notificationsSidebar = false
                  }
                }
              },
              [
                _c("notifications", {
                  staticClass: "sidebar-left",
                  on: {
                    close: function($event) {
                      _vm.notificationsSidebar = false
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "sidebar-item",
          attrs: { href: "https://docs.mod24.com/mod24/", target: "_blank" }
        },
        [
          _c("div", { staticClass: "mod-icon mod-icon-help" }),
          _vm._v(" "),
          _c("span", { staticClass: "l-menu-title" }, [_vm._v("Help")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "sidebar-item",
          attrs: { href: "https://docs.mod24.com/mod24/", target: "_blank" }
        },
        [
          _c("div", { staticClass: "mod-icon mod-icon-help" }),
          _vm._v(" "),
          _c("span", { staticClass: "l-menu-title" }, [_vm._v("Help")])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fe34c1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe34c1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/LayoutSidebar.vue
// module id = null
// module chunks = 